import React, { useState, useRef, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const PayrollAddIncentive = ({
  toggleOffCanvasAction,
  setIsOffCanvasOpenAction,
  isOffCanvasOpenAction,
  types,
  item,
  fetchTypes,
  fetchPayrollFn
}) => {
  const options = ["Bonus"];
  const { baseUrl, openToast, selectedStaffIds } = useGlobalContext();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [open, setOpen] = useState(false);
  const [incentiveName, setincentiveName] = React.useState("");
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [createname, setcreateName] = useState("");
  const [staffId, setStaffId] = useState("");
  const [amount, setAmount] = useState("");
  const [date, setDate] = useState("");
  const [note, setNote] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const sidebarRef = useRef(null);


  async function addIncentive() {
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + "incentives/type/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({ name: incentiveName }),
      });
      if (result.status == 201) {
        openToast("Incentive Added Successfully", "success");
        setIsOpen();
        fetchTypes();
      } else {
        openToast("Something went wrong", "error");
      }
      console.log(result);
    } catch (error) {
      openToast("Something went wrong!", "error");
    }
    finally {
      setIsLoading(false)

    }
  }

  async function createIncentiveFunction() {
    try {
      setIsLoading(true)
      console.log(selectedOption);
      const result = await fetch(baseUrl + "/incentives", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          staffId: item?.staffDetails?.id,
          incentiveTypeId: selectedOption?.id,
          amount: parseFloat(amount),
          date: date,
          note: note,
          salaryId: item?.staffDetails?.SalaryDetails[0]?.id,
        }),
      });
      if (result.status == 201) {
        openToast("Incentive Added Successfully", "success");
        setIsOffCanvasOpenAction();
        fetchPayrollFn()
      } else {
        openToast("Something went wrong", "error");
      }
      console.log(result);
    } catch (error) {
      openToast("Something went wrong!", "error");
    }
    finally {
      setIsLoading(false)
    }
  }


  useEffect(() => {
    function handleClickOutside(event) {
        if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
            setIsOffCanvasOpenAction(); // Close sidebar if clicked outside
        }
    }

    if (isOffCanvasOpenAction) {
        document.addEventListener("mousedown", handleClickOutside);
    } else {
        document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, [isOffCanvasOpenAction, setIsOffCanvasOpenAction]);

  return (
    <div
    ref={sidebarRef}
    className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${
        isOffCanvasOpenAction ? "translate-x-0" : "translate-x-full"
    }`}
    >
      <div className="relative w-full h-full">
        <div className="flex justify-between items-center border-gray-200 p-4 border-b">
          <h2 className="font-semibold text-[#000] text-[18px]">
            {item?.name}
          </h2>
          <button className="text-[black]" onClick={setIsOffCanvasOpenAction}>
            <CloseIcon />
          </button>
        </div>
        <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">
          <div className="flex justify-between items-center bg-[#e5e7eb3b] mb-[10px] p-[10px] w-full">
            <p className="font-normal text-md text-muted-foreground">
              Add Incentive
            </p>
          </div>
          <div className="flex justify-between items-center pt-[14px]">
            <label className="font-light text-[14px]">Type</label>
            <div className="">
              <div className="relative">
                {/* Dropdown Button */}
                <button
                  onClick={() => setIsOpen(!isOpen)}
                  className="focus:shadow-cs px-[10px] py-[6px] pl-[12px] border rounded-[10px] w-[232px] focus-visible:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span
                      className={
                        selectedOption
                          ? "text-gray-900"
                          : "text-gray-500 text-[15px]"
                      }
                    >
                      {selectedOption?.name || "Select Incentive Type"}
                    </span>
                    <svg
                      className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isOpen ? "transform rotate-180" : ""
                        }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>
                </button>

                {/* Dropdown Menu */}
                {isOpen && (
                  <div className="z-10 absolute border-gray-200 bg-white shadow-lg mt-1 border rounded-lg w-full h-[163px] overflow-y-scroll">
                    <ul className="py-1">
                      {types.map((type) => (
                        <li key={type.id}>
                          <button
                            onClick={() => {
                              setSelectedOption(type); // Set the full object here
                              setIsOpen(false);
                            }}
                            className="hover:bg-gray-50 px-4 py-2 w-full text-gray-700 text-left focus:outline-none"
                          >
                            {type.name}
                          </button>
                        </li>
                      ))}
                      <li className="px-4 py-2 border-t">
                        <div>
                          <button
                            className="text-[#8a25b0] text-sm focus:outline-none"
                            onClick={onOpenModal}
                          >
                            {" "}
                            + Add Incentive Type
                          </button>
                            <Modal open={open} onClose={onCloseModal} center>
                              {/* Modal Header */}
                              <div className="flex justify-between items-center pb-[16px] border-b">
                                <h2 className="font-semibold text-[14px] text-gray-800 md:text-[18px]">
                                  Add New Incentive Type
                                </h2>
                              </div>
                              {/* Modal Content */}
                              <div className="bg-white rounded-lg w-full">
                                <div>
                                  <div className="pt-[24px] pb-[30px]">
                                    <label
                                      htmlFor="incentiveName"
                                      className="block mb-2 font-medium text-gray-700 text-md"
                                    >
                                      Incentive Name
                                    </label>
                                    <input
                                      type="text"
                                      onChange={(e) =>
                                        setincentiveName(e.target.value)
                                      }
                                      className="border-[#dbdbdb] focus:shadow-cs px-3 py-2 border rounded-lg w-full focus:outline-none newsetup3"
                                      placeholder="Enter incentive name"
                                      required
                                    />
                                  </div>

                                  {/* Modal Footer */}
                                  <div className="flex justify-end gap-3 pt-[20px] border-t">
                                    <button
                                      type="button"
                                      onClick={() => setIsOpen(false)}
                                      className="first-btn"
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      onClick={addIncentive}
                                      type="submit"
                                      className={`second-btn ${isLoading == true ? 'opacity-50 cursor-not-allowed' : ''}`}
                                      disabled={isLoading}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>

                                {/* Modal Body */}
                              </div>
                            </Modal>
                        </div>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex justify-between items-center pt-[14px]">
            <label className="font-light text-[14px]">Amount</label>
            <div className="relative">
              <input
                onChange={(e) => setAmount(e.target.value)}
                type="text"
                className="focus:shadow-cs px-[10px] py-[5px] pl-[24px] border rounded-[10px] w-[232px] focus-visible:outline-none"
              />
              <span className="top-[6px] left-[12px] absolute">₹</span>
            </div>
          </div>
          <div className="flex justify-between items-center pt-[14px]">
            <label className="font-light text-[14px]">Payment Date</label>
            <div className="">
              <input
                onChange={(e) => setDate(e.target.value)}
                type="date"
                className="focus:shadow-cs px-[10px] py-[5px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none"
              />
            </div>
          </div>
          <div className="flex justify-between items-center pt-[14px]">
            <label className="font-light text-[14px]">Notes</label>
            <div className="">
              <textarea
                onChange={(e) => setNote(e.target.value)}
                className="focus:shadow-cs px-[10px] py-[5px] pl-[20px] border rounded-[10px] w-[232px] font-light focus-visible:outline-none"
              />
            </div>
          </div>
          <div className="bottom-[40px] sm:bottom-[20px] left-0 absolute w-full">
            <div className="flex justify-between px-[20px]">
              <button
                className="w-[48%] first-btn"
                onClick={setIsOffCanvasOpenAction}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  createIncentiveFunction();
                  // setSelectedStaff(staff);
                }}
                disabled={isLoading}
                className={`justify-center sm:w-[48%] second-btn ${isLoading && isLoading == true ? "opacity-50 cursor-not-allowed" : "opacity-100"}`}
              >
                Save Payment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayrollAddIncentive;
